<div class="back_button icon_cover" (click)="goBack()" title="Go Back">
  <app-svg-icon [path]="'assets/icons/back_button.svg'"></app-svg-icon>
</div>
